// Push notification registration helper for CarnesWork.
// Requests browser permission, obtains FCM token, and stores it on the backend.

import api from "@/lib/api";
import { isPushConfigured, requestFcmToken, onForegroundMessage } from "@/lib/firebase";
import { toast } from "sonner";

let foregroundBound = false;

export async function enablePushNotifications({ silent = false } = {}) {
  if (!isPushConfigured()) {
    if (!silent) toast.error("Notificações não configuradas neste servidor.");
    return { ok: false, reason: "not_configured" };
  }
  if (typeof window === "undefined" || !("Notification" in window)) {
    if (!silent) toast.error("Seu navegador não suporta notificações.");
    return { ok: false, reason: "unsupported" };
  }

  const token = await requestFcmToken();
  if (!token) {
    if (!silent) toast.error("Permissão negada ou navegador não suportado.");
    return { ok: false, reason: "denied" };
  }

  try {
    await api.post("/push/register", { token, platform: "web" });
    bindForegroundListener();
    if (!silent) toast.success("Notificações ativadas neste dispositivo.");
    return { ok: true, token };
  } catch (e) {
    console.warn("[push] backend register failed:", e);
    if (!silent) toast.error("Falha ao registrar dispositivo.");
    return { ok: false, reason: "backend_error" };
  }
}

export async function disablePushNotifications() {
  try {
    const token = await requestFcmToken();
    if (token) await api.post("/push/unregister", { token });
    toast.success("Notificações desativadas neste dispositivo.");
    return { ok: true };
  } catch {
    return { ok: false };
  }
}

export function bindForegroundListener() {
  if (foregroundBound) return;
  foregroundBound = true;
  onForegroundMessage((payload) => {
    const title = payload?.notification?.title || payload?.data?.title;
    const body = payload?.notification?.body || payload?.data?.body;
    const url = payload?.data?.click_url;
    if (!title && !body) return;
    toast(title || "Notificação", {
      description: body,
      action: url ? { label: "Abrir", onClick: () => (window.location.href = url) } : undefined,
    });
  });
}

// Best-effort silent registration on app load if the user already granted permission
export async function autoRegisterIfPermitted() {
  if (!isPushConfigured()) return;
  if (typeof window === "undefined" || !("Notification" in window)) return;
  if (Notification.permission !== "granted") return;
  await enablePushNotifications({ silent: true });
}
